import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class BanditCampSmallSalvageableTileEntity extends TileEntity {
	public static readonly frameName = FrameName.BANDIT_CAMP_SMALL;
}

export default BanditCampSmallSalvageableTileEntity;
